import { render, staticRenderFns } from "./doviztutarcomp.vue?vue&type=template&id=447a8fe3&scoped=true"
import script from "./doviztutarcomp.vue?vue&type=script&lang=js"
export * from "./doviztutarcomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a8fe3",
  null
  
)

export default component.exports